import PropTypes from 'prop-types';
import compose from "ramda/es/compose";
import defaultTo from "ramda/es/defaultTo";
import head from "ramda/es/head";
import propOr from "ramda/es/propOr";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import RadioButton from '@gef-ui/components/atoms/RadioButton';
import ComponentLoader from '@gef-ui/components/molecules/ComponentLoader';
import RadioButtonGroup from '@gef-ui/components/molecules/RadioButtonGroup';
import { Grid, GridAlignTypes, GridCol, GridDisplaySizes } from '@gef-ui/components/organisms/Grid';
import { getLabelMessage } from '@gef-ui/localization/messages';
import { resolveDelegations } from '../../actions';
import { setDelegationCookies } from '../../utils';
import CenteredButton from '../CenteredButton';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'ChooseDelegation';
const ChooseDelegation = (inProps)=>{
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { delegations, allowedCompany, continueAction, userInfoEndpointCreators, selectors } = props;
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const firstDelegation = useMemo(()=>{
        return compose(propOr(null, 'userLogon'), defaultTo({}), head, defaultTo([]))(delegations);
    }, [
        delegations
    ]);
    const [representativeFor, setRepresentativeFor] = useState(firstDelegation);
    const handleChange = (_e, value)=>{
        setRepresentativeFor(value);
    };
    const handleClick = useCallback(()=>{
        setLoading(true);
        setDelegationCookies(representativeFor);
        dispatch(resolveDelegations({
            continueAction,
            ...selectors,
            ...userInfoEndpointCreators
        }));
    }, [
        representativeFor,
        dispatch,
        continueAction,
        userInfoEndpointCreators,
        selectors
    ]);
    if (isNilOrEmpty(delegations)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "Delegations-divider"
    }, getLabelMessage(allowedCompany ? 'delegations:orInDelegations' : 'delegations:inDelegations')), /*#__PURE__*/ React.createElement(Grid, {
        alignmentsForDisplays: [
            {
                [GridDisplaySizes.XS]: GridAlignTypes.CENTER
            }
        ]
    }, /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 10,
        sizeSM: 5
    }, /*#__PURE__*/ React.createElement(RadioButtonGroup, {
        value: representativeFor,
        onChange: handleChange
    }, delegations.map(({ firstName, surname, userLogon })=>{
        const label = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", null, `${surname} ${firstName}`), /*#__PURE__*/ React.createElement("span", {
            className: "Text--disabled"
        }, ` (${userLogon})`));
        return /*#__PURE__*/ React.createElement(RadioButton, {
            value: userLogon,
            key: userLogon,
            label: label
        });
    })))), /*#__PURE__*/ React.createElement(ComponentLoader, {
        isLoading: loading
    }, /*#__PURE__*/ React.createElement(CenteredButton, {
        label: "delegations:enter",
        onClick: handleClick
    })));
};
export const delegationsShape = PropTypes.arrayOf(PropTypes.shape({
    firstName: PropTypes.string,
    surname: PropTypes.string,
    userLogon: PropTypes.string
}));
ChooseDelegation.propTypes = {
    allowedCompany: PropTypes.bool,
    continueAction: PropTypes.func,
    delegations: delegationsShape,
    selectors: PropTypes.shape({
        getIsLogoutFetchLoaded: PropTypes.func,
        getIsOriginalUserFetchLoaded: PropTypes.func
    }),
    userInfoEndpointCreators: PropTypes.shape({
        createFetchAction: PropTypes.func,
        createFetchActionWithRepresentedUser: PropTypes.func
    })
};
export default ChooseDelegation;
